// @flow

import Colors from './Colors';
import WebMetrics from './WebMetrics';

const Styles = {
    // Layout components
    whiteBox: {
        margin: WebMetrics.containerMetrics.margin,
        background: Colors.white,
        padding: WebMetrics.containerMetrics.margin
    }
};

export default Styles;
